import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Config } from '@/config';
import {
  errorModalTextRecoil,
  completeModalRecoil,
  deleteModalRecoil,
  imgDetailModalRecoil,
  deviceModifyModalRecoil,
  deviceCommandAddModalRecoil,
} from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import TitleTextBox from '@/component/TitleTextBox';
import Pagenation from '@/component/Pagenation';
import SearchBtn from '@/component/SearchBtn';
import DeleteModal from '@/modal/DeleteModal';
import AlarmCorrectionModifyModal from '@/modal/AlarmCorrectionModifyModal';
import EventPlusModal from '@/modal/EventAddModal';
import LabelType1 from '@/component/LabelType1';
import SensorData from './device/SensorData';
import TextData from './device/TextData';
import SettingChangeHistory from './device/SettingChangeHistory';
import EventSetting from './device/EventSetting';
import DataGraph from './device/DataGraph';
import DeviceCommand from './device/DeviceCommand';
import { DeviceApi } from '@/sdk/DeviceApi';
import { deviceDetailRecoil } from '@/atom/DeviceAtom';
import { DeleteDeviceDtoTx } from '@/sdk/data-contracts';
import ImgModal from '@/modal/ImgModal';
import DeviceModifyModal from '@/modal/DeviceModifyModal';
import DeviceCommandModal from '@/modal/DeviceCommandAddModal';

const DeviceDetail = () => {
  const { id } = useParams<{ id: string }>();
  const deviceApi = new DeviceApi({ baseURL: Config.API_URL });
  const navigate = useNavigate();

  const setErrorModalText = useSetRecoilState(errorModalTextRecoil);
  const setCompleteModalState = useSetRecoilState(completeModalRecoil);
  const [deleteModalState, setDeleteModalState] =
    useRecoilState(deleteModalRecoil);
  const [imgDetailModalState, setImgDetailModalState] =
    useRecoilState(imgDetailModalRecoil);
  const [deviceModifyModalState, setDeviceModifyModalState] = useRecoilState(
    deviceModifyModalRecoil,
  );
  const [deviceCommandModalState, setDeviceCommandAddModalState] =
    useRecoilState(deviceCommandAddModalRecoil);
  const [deviceDetailState, setDeviceDetailState] =
    useRecoilState(deviceDetailRecoil);

  const [tab1ActiveIndex, setTab1ActiveIndex] = useState<number>(0);

  const fetchDeviceDetail = async () => {
    try {
      const { data } = await deviceApi.deviceControllerGetDeviceDetail(
        Number(id),
        {
          headers: {
            Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
            'Content-Type': 'application/json',
          },
        },
      );
      setDeviceDetailState(data);
    } catch (err: any) {}
  };

  const handleDeviceDelete = async () => {
    try {
      const dto: DeleteDeviceDtoTx = {
        ids: [Number(id)],
      };
      await deviceApi.deviceControllerDeleteDevice(dto, {
        headers: {
          Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
          'Content-Type': 'application/json',
        },
      });
      navigate('/device');
    } catch (err: any) {}
  };

  useEffect(() => {
    fetchDeviceDetail();
  }, []);

  return (
    <>
      <CntBox1>
        <div className="flex aic jcsb">
          <TitleTextBox text="디바이스 상세 정보" />
          <BS.BtnBox1>
            <BS.Btn1Type1 type="button" onClick={() => navigate('/device')}>
              목록
            </BS.Btn1Type1>
            <BS.Btn1Type1
              type="button"
              onClick={() => setDeviceModifyModalState(true)}
            >
              수정
            </BS.Btn1Type1>
            <BS.Btn1Type2 type="button" onClick={handleDeviceDelete}>
              삭제
            </BS.Btn1Type2>
          </BS.BtnBox1>
        </div>
        <InforWrap>
          <InforBox1>
            <h1>디바이스 기본정보</h1>
            <div className="text-wrap">
              <ul className="text-box">
                <li>
                  <h2 style={{ minWidth: 110 }}>모델</h2>
                  <p>{deviceDetailState?.modelName}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 110 }}>디바이스 No</h2>
                  <p>{deviceDetailState?.number}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 110 }}>통신상태</h2>
                  <p>{deviceDetailState?.communicationStatus}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 110 }}>메모</h2>
                  <p>{deviceDetailState?.memo}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 110 }}>첨부파일</h2>
                  <p>
                    <button
                      className="click-btn"
                      onClick={() =>
                        window.open(deviceDetailState?.fileUrl, '_blank')
                      }
                    >
                      {deviceDetailState?.fileName}
                    </button>
                  </p>
                </li>
              </ul>
              <ul className="text-box">
                <li>
                  <h2 style={{ minWidth: 101 }}>디바이스명</h2>
                  <p>{deviceDetailState?.name}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 101 }}>Dev EUI</h2>
                  <p>{deviceDetailState?.devEui}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 101 }}>센서 상태</h2>
                  <p>{deviceDetailState?.sensorStatus}</p>
                </li>
              </ul>
            </div>
            <BS.Btn1Type3
              type="button"
              className="device-btn"
              onClick={() => setDeviceCommandAddModalState(true)}
            >
              디바이스 명령어 전송
            </BS.Btn1Type3>
          </InforBox1>
          <InforBox2>
            <h1>디바이스 설치 정보</h1>
            <div className="text-wrap">
              <ul className="text-box">
                <li>
                  <h2 style={{ minWidth: 90 }}>시설 번호</h2>
                  <p>{deviceDetailState?.facilityNumber}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 90 }}>시설명</h2>
                  <p>{deviceDetailState?.facilityName}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 90 }}>설치 위치</h2>
                  <p>{deviceDetailState?.location}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 90 }}>주소</h2>
                  <p>{deviceDetailState?.address}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 90 }}>설치 일자</h2>
                  <p>{deviceDetailState?.setupDate}</p>
                </li>
              </ul>
            </div>
          </InforBox2>
          <InforBox3>
            <h1>도면/이미지</h1>
            {deviceDetailState?.imageUrl !== '' && (
              <div className="img-area">
                <span className="img-box">
                  <img src={String(deviceDetailState?.imageUrl)} alt="" />
                </span>
                <button
                  type="button"
                  onClick={() => setImgDetailModalState(true)}
                >
                  <span className="img-box">
                    <img src="/img/ico_arrows_292D32.svg" alt="" />
                  </span>
                </button>
              </div>
            )}
          </InforBox3>
        </InforWrap>
      </CntBox1>
      <CntBox2>
        <CS.TabMenuType1Mini>
          <button
            type="button"
            className={tab1ActiveIndex === 0 ? 'active' : ''}
            onClick={() => setTab1ActiveIndex(0)}
          >
            센서 데이터
          </button>
          <button
            type="button"
            className={tab1ActiveIndex === 1 ? 'active' : ''}
            onClick={() => setTab1ActiveIndex(1)}
          >
            원본 데이터
          </button>
          <button
            type="button"
            className={tab1ActiveIndex === 2 ? 'active' : ''}
            onClick={() => setTab1ActiveIndex(2)}
          >
            설정 변경 이력
          </button>
          <button
            type="button"
            className={tab1ActiveIndex === 3 ? 'active' : ''}
            onClick={() => setTab1ActiveIndex(3)}
          >
            이벤트 설정
          </button>
          <button
            type="button"
            className={tab1ActiveIndex === 4 ? 'active' : ''}
            onClick={() => setTab1ActiveIndex(4)}
          >
            데이터 그래프
          </button>
          <button
            type="button"
            className={tab1ActiveIndex === 5 ? 'active' : ''}
            onClick={() => setTab1ActiveIndex(5)}
          >
            디바이스 명령어
          </button>
        </CS.TabMenuType1Mini>
        {tab1ActiveIndex === 0 && <SensorData />}
        {tab1ActiveIndex === 1 && <TextData />}
        {tab1ActiveIndex === 2 && <SettingChangeHistory />}
        {tab1ActiveIndex === 3 && <EventSetting />}
        {tab1ActiveIndex === 4 && <DataGraph />}
        {tab1ActiveIndex === 5 && <DeviceCommand />}
      </CntBox2>
      {imgDetailModalState && (
        <ImgModal fileUrl={String(deviceDetailState?.imageUrl)} />
      )}
      {deviceModifyModalState && <DeviceModifyModal modifyNum={Number(id)} />}
      {deviceCommandModalState && <DeviceCommandModal />}
      {/* {deviceCommandModalState && <DeviceCommandModal />}
      {alarmCorrectionModifyModalState && <AlarmCorrectionModifyModal />}
      {eventPlusModalState && <EventPlusModal />}
      {deleteModalState && <DeleteModal onConfirm={handleSelectDelete} />} */}
    </>
  );
};

export default DeviceDetail;

export const CntBox1 = styled(CS.CntBoxType1)`
  width: 100%;
`;

export const CntBox2 = styled(CS.CntBoxType1)`
  width: 100%;
  margin-top: 20px;
`;

export const InforWrap = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  margin-top: 16px;
`;

export const InforBox1 = styled(CS.CntBoxType2)`
  position: relative;
  width: calc(50% - 13.3333px);
  > .device-btn {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
`;

export const InforBox2 = styled(CS.CntBoxType2)`
  width: calc(25% - 13.3333px);
  > .text-wrap {
    &:before {
      display: none;
    }
    > .text-box {
      width: 100%;
      &:first-child {
        padding-right: 0;
      }
      &:last-child {
        padding-left: 0;
      }
    }
  }
`;

export const InforBox3 = styled(CS.CntBoxType2)`
  width: calc(25% - 13.3333px);
  > .img-area {
    width: 100%;
    position: relative;
    margin-top: 12px;
    > button {
      position: absolute;
      width: 34px;
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      border: 1px solid #ececec;
      background: #fff;
      border-radius: 4px;
      left: 10px;
      bottom: 10px;
      > .img-box {
        width: 24px;
      }
    }
  }
`;

export const SearchOptionBox = styled(CS.SearchOptionBox)`
  width: 100%;
  margin-top: 20px;
`;

export const InputWrap = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const InputArea = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  > h2 {
    color: #555;
    font-size: 14px;
  }
`;

export const TabCntBox = styled.div`
  width: 100%;
  margin-top: 20px;
`;

export const TableOpitonBox = styled(CS.TableOpitonBox)`
  width: 100%;
  margin-top: 0;
`;

export const TableOpitonBox2 = styled(TableOpitonBox)`
  margin-top: 32px;
`;

export const TableBox = styled(CS.TableType1)`
  width: 100%;
  margin-top: 16px;
  margin-bottom: 32px;
`;

export const MapBox = styled.div`
  width: 100%;
  height: 400px;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
`;

export const MapModal = styled.div`
  position: absolute;
  z-index: 10;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  width: 136px;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  box-shadow: 4px 4px 12px 0px rgba(255, 255, 255, 0.25);
  overflow: hidden;
  > .title-box {
    box-sizing: border-box;
    padding: 8px 12px;
    background: #e9e8e8;
    font-size: 16px;
    font-weight: 500;
  }
  > .text-box {
    box-sizing: border-box;
    padding: 12px;
    background: #fff;
    > .state-box {
      display: flex;
      align-items: center;
      gap: 8px;
      > .text {
        font-size: 15px;
      }
      > .line {
        width: 1px;
        height: 10px;
        background: #d9d9d9;
      }
    }
    > .date {
      margin-top: 6px;
      font-size: 12px;
      font-weight: 300;
      color: #777;
    }
    > button {
      margin-top: 8px;
      font-size: 14px;
      color: #3c8deb;
    }
  }
`;

export const MapTextModal = styled.div`
  position: absolute;
  z-index: 10;
  top: 50%;
  left: 70%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  padding: 10px 16px;
  box-shadow: 4px 4px 12px 0px rgba(255, 255, 255, 0.25);
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  > p {
    font-size: 15px;
    white-space: nowrap;
  }
  > button {
    width: 10px;
    min-width: 10px;
  }
`;

export const GraphBox = styled.div`
  margin-top: 16px;
  width: 100%;
  height: 280px;
  box-sizing: border-box;
  border-top: 2px solid #222222;
`;
